import LayoutPage from "../../Components/LayoutPage"
import ChallengeList from "./Components/ChallengeList"

export default function Challenges() {
  return (
    <LayoutPage activeIndex={4} navItems={["مدیریت چالش‌ها"]} childrenClassName="flex-1 min-h-0 flex flex-col gap-5 overflow-auto">
      <ChallengeList/>
    </LayoutPage>
  )
}